import { fcaFastApi, fcaGateWay, fcaReportGateway } from "../../../../services/authorizationService";
import * as serviceEndpoints from "../../../../config/serviceEndPoints";
import { checkPermission } from "../../../../config/utils";
import { isEnabled } from "../../../../services/featureFlags";

export const fieldData = {
    addition_id: {
        formHeading: "Addition",
        fieldKeys: ["name", "building_id", "client_id", "consultancy_id", "description"],
        fields: {
            name: {
                label: "Addition Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            consultancy_id: {
                label: "Consultancy",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "consultancy_id",
                dropdownField: "consultancy"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            },
            building_id: {
                label: "Building",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "building_id",
                dropdownFn: params => fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAllBuildingsDropdown}/buildings_dropdown`, { params }),
                dropdownField: "building",
                paramFields: ["site_id", "project_ids"],
                readOnly: true
            },
            description: {
                label: "Description",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (building_id, params) => fcaGateWay.post(`${serviceEndpoints.additionEndPoints.addAddition}/${building_id}/additions`, params),
        nameField: "name",
        permission: checkPermission("forms", "building_additions", "create")
    },
    building_id: {
        formHeading: "Building",
        fieldKeys: [
            "name",
            "main_building_type_id",
            "project_ids",
            "description",
            "client_id",
            "consultancy_id",
            "region_id",
            "site_id",
            "ownership_type"
        ],
        fields: {
            name: {
                label: "Building Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            main_building_type_id: {
                label: "Building Type",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                dropdownFn: params =>
                    fcaGateWay.get(`${serviceEndpoints.buildingEndPoints.getBuildingTypesBasedOnClient}/building_types_dropdown`, { params }),
                dropdownField: "building_type",
                paramFields: ["client_id"],
                autoFieldKey: "main_building_type_id",
                readOnly: true
            },
            consultancy_id: {
                label: "Consultancy",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "consultancy_id",
                dropdownField: "consultancy"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            },
            project_ids: {
                label: "Project",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                dropdownField: "project",
                autoFieldKey: "project_ids"
            },
            region_id: {
                label: "Region",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "region_id",
                dropdownFn: params => fcaGateWay.get(`${serviceEndpoints.buildingTypeEndPoints.getRegionsBasedOnClient}`, { params }),
                dropdownField: "region",
                paramFields: ["client_id"],
                readOnly: true
            },
            site_id: {
                label: "Site",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "site_id",
                dropdownFn: params => fcaGateWay.get(`${serviceEndpoints.buildingEndPoints.getSitesBasedOnRegion}/${params?.region_id}/sites`),
                dropdownField: "site",
                paramFields: ["region_id"],
                readOnly: true
            },
            description: {
                label: "Description",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            ownership_type: {
                label: "Ownership Type",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                fieldOptions: [
                    { name: "Owned", id: "Owned" },
                    { name: "Leased", id: "Leased" }
                ],
                defaultValue: "Owned"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(serviceEndpoints.buildingEndPoints.addBuilding, params),
        nameField: "name",
        permission: checkPermission("forms", "buildings", "create")
    },
    region_id: {
        formHeading: "Region",
        fieldKeys: ["name", "consultancy_id", "client_id", "project_ids"],
        fields: {
            name: {
                label: "Region Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            consultancy_id: {
                label: "Consultancy",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "consultancy_id",
                dropdownField: "consultancy",
                readOnly: true
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                dropdownField: "client",
                autoFieldKey: "client_id"
            },
            project_ids: {
                label: "Project",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                dropdownField: "project",
                autoFieldKey: "project_ids",
                readOnly: true
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(serviceEndpoints.regionEndPoints.addRegion, params),
        nameField: "name",
        permission: checkPermission("forms", "regions", "create")
    },
    site_id: {
        formHeading: "Site",
        fieldKeys: ["name", "consultancy_id", "client_id", "project_ids", "region_id"],
        fields: {
            name: {
                label: "Site Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            consultancy_id: {
                label: "Consultancy",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "consultancy_id",
                dropdownField: "consultancy"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                dropdownField: "client",
                autoFieldKey: "client_id"
            },
            region_id: {
                label: "Region",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "region_id",
                dropdownFn: params => fcaGateWay.get(`${serviceEndpoints.buildingTypeEndPoints.getRegionsBasedOnClient}`, { params }),
                dropdownField: "region",
                paramFields: ["client_id"],
                readOnly: true
            },
            project_ids: {
                label: "Project",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                dropdownField: "project",
                autoFieldKey: "project_ids",
                readOnly: true
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(serviceEndpoints.siteEndPoints.addSite, params),
        nameField: "name",
        permission: checkPermission("forms", "sites", "create")
    },
    floor: {
        formHeading: "Floor",
        fieldKeys: ["name", "consultancy_id", "client_id", "building_id", "description", "sort_order"],
        fields: {
            name: {
                label: "Floor Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            description: {
                label: "Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            },
            consultancy_id: {
                label: "Consultancy",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                dropdownField: "consultancy",
                autoFieldKey: "consultancy_id",
                readOnly: true
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                dropdownField: "client",
                autoFieldKey: "client_id"
            },
            building_id: {
                label: "Building",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "building_id",
                dropdownFn: params => fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAllBuildingsDropdown}/buildings_dropdown`, { params }),
                dropdownField: "building",
                paramFields: ["site_id", "project_id"],
                readOnly: true
            },
            sort_order: {
                label: "Sort Order",
                mandatory: false,
                showInForm: true,
                fieldType: "number",
                isZeroNotAllowed: true
            }
        },
        serviceFn: (building_id, params) => fcaGateWay.post(`${serviceEndpoints.floorEndPoints.addFloor}/${building_id}/floors`, params),
        nameField: "name",
        permission: checkPermission("forms", "floors", "create")
    },
    trade_id: {
        formHeading: "Trade",
        fieldKeys: ["name", "display_name", "table_header", "description", "color_code"],
        fields: {
            name: {
                label: "Trade Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            display_name: {
                label: "Display Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            table_header: {
                label: "BBI Heading",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            description: {
                label: "Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            },
            color_code: {
                label: "Building",
                mandatory: false,
                showInForm: true,
                fieldType: "color"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(`${serviceEndpoints.projectEndPoints.addTrade}/${id}/trades`, params),
        nameField: "name",
        permission: checkPermission("forms", "master_trades", "create")
    },
    system_id: {
        formHeading: "System",
        fieldKeys: ["name", "trade_id", "description", "color_code"],
        fields: {
            name: {
                label: "System Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            trade_id: {
                label: "Trade",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "trade_id",
                dropdownFn: params =>
                    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getSystemBasedOnProject}/${params?.project_id}/trades_dropdown`),
                dropdownField: "trade",
                paramFields: ["project_ids"],
                readOnly: true
            },

            description: {
                label: "Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            },
            color_code: {
                label: "Color",
                mandatory: false,
                showInForm: true,
                fieldType: "color"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(`${serviceEndpoints.projectEndPoints.addSystem}/${id}/systems`, params),
        nameField: "name",
        permission: checkPermission("forms", "master_systems", "create")
    },
    sub_system_id: {
        formHeading: "Subsystem",
        fieldKeys: ["name", "trade_id", "system_id", "description"],
        fields: {
            name: {
                label: "Subsystem Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            trade_id: {
                label: "Trade",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "trade_id",
                dropdownFn: params =>
                    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getSystemBasedOnProject}/${params?.project_id}/trades_dropdown`),
                dropdownField: "trade",
                paramFields: ["project_ids"],
                readOnly: true
            },
            system_id: {
                label: "System",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "system_id",
                dropdownFn: params =>
                    fcaGateWay.get(`${serviceEndpoints.recommendationEndPoints.getSystemBasedOnProject}/${params?.project_id}/systems_dropdown`, {
                        params
                    }),
                dropdownField: "systems",
                paramFields: ["trade_id", "project_ids"],
                readOnly: true
            },
            description: {
                label: "Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(`${serviceEndpoints.projectEndPoints.addSubsystem}/${id}/sub_systems`, params),
        nameField: "name",
        permission: checkPermission("forms", "master_sub_systems", "create")
    },
    criticality_id: {
        formHeading: "Criticality",
        fieldKeys: ["name", "start_range", "end_range", "color_code"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            start_range: {
                label: "Scale From",
                mandatory: true,
                showInForm: true,
                fieldType: "number",
                decimalScale: 6
            },
            end_range: {
                label: "Scale To",
                mandatory: true,
                showInForm: true,
                fieldType: "number",
                decimalScale: 6
            },
            color_code: {
                label: "Color",
                mandatory: false,
                showInForm: true,
                fieldType: "color"
            }
        },
        serviceFn: (project_id, params) => fcaGateWay.post(`${serviceEndpoints.projectEndPoints.addCriticality}/${project_id}/criticalities`, params),
        nameField: "name",
        permission: true
    },
    asset_condition_id: {
        formHeading: "Condition",
        fieldKeys: ["name", "description"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            description: {
                label: "Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(`${serviceEndpoints.projectEndPoints.addAssetCondition}/${id}/asset_conditions`, params),
        nameField: "name",
        permission: checkPermission("forms", "asset_conditions", "create")
    },
    category_id: {
        formHeading: "Category",
        fieldKeys: ["name", "description", "color_code"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            description: {
                label: "Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            },
            color_code: {
                label: "Color",
                mandatory: false,
                showInForm: true,
                fieldType: "color"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(`${serviceEndpoints.projectEndPoints.addCategory}/${id}/categories`, params),
        nameField: "name",
        permission: checkPermission("forms", "categories", "create")
    },
    department_id: {
        formHeading: "Department",
        fieldKeys: ["name", "description"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            description: {
                label: "Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(`${serviceEndpoints.projectEndPoints.addDepartment}/${id}/departments`, params),
        nameField: "name",
        permission: checkPermission("forms", "consultancies", "create")
    },
    funding_source_id: {
        formHeading: "Funding",
        fieldKeys: ["name", "description", "color_code"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            description: {
                label: "Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            },
            color_code: {
                label: "Color",
                mandatory: false,
                showInForm: true,
                fieldType: "color"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(`${serviceEndpoints.projectEndPoints.addFundingsource}/${id}/funding_sources`, params),
        nameField: "name",
        permission: checkPermission("forms", "funding_sources", "create")
    },
    responsibility_id: {
        formHeading: "Responsibility",
        fieldKeys: ["name", "description", "color_code"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            description: {
                label: "Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            },
            color_code: {
                label: "Color",
                mandatory: false,
                showInForm: true,
                fieldType: "color"
            }
        },
        serviceFn: (id, params) =>
            fcaGateWay.post(`${serviceEndpoints.responsibilityEndPoints.responsibility}/${id}/responsibilities`, { responsibilities: params }),
        nameField: "name",
        permission: checkPermission("forms", "responsibility", "create")
    },
    initiative_id: {
        formHeading: "Initiative",
        fieldKeys: ["name", "consultancy_id", "client_id", "project_id", "status"],
        fields: {
            name: {
                label: "Initiative Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            consultancy_id: {
                label: "Consultancy",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "consultancy_id",
                dropdownField: "consultancy"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            },
            project_id: {
                label: "Project",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                dropdownField: "project",
                autoFieldKey: "project_ids",
                readOnly: true
            },
            status: {
                label: "Status",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                fieldOptions: [
                    { name: "Active", id: "active" },
                    { name: "In Progress", id: "in_progress" },
                    { name: "Pending", id: "pending" },
                    { name: "On Hold", id: "on_hold" },
                    { name: "Completed", id: "completed" }
                ],
                defaultValue: "pending"
            }
        },
        serviceFn: (id, param) => fcaGateWay.post(serviceEndpoints.initiativeEndPoints.getInitiatives, param),
        nameField: "name",
        permission: checkPermission("forms", "initiatives", "create")
    },
    main_building_type_id: {
        formHeading: "Building Type",
        fieldKeys: ["name", "client_id", "consultancy_id", "description"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            consultancy_id: {
                label: "Consultancy",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "consultancy_id",
                dropdownField: "consultancy"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            },
            description: {
                label: "Description",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(serviceEndpoints.buildingTypeEndPoints.addBuildingType, params),
        nameField: "name",
        permission: checkPermission("forms", "main_building_types", "create")
    },
    "assets.addition_id": {
        formHeading: "Addition",
        fieldKeys: ["name", "building_id", "client_id", "consultancy_id", "description"],
        fields: {
            name: {
                label: "Addition Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            consultancy_id: {
                label: "Consultancy",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "consultancy_id",
                dropdownField: "consultancy"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            },
            building_id: {
                label: "Building",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "building_id",
                dropdownFn: params => fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAllBuildingsDropdown}/buildings_dropdown`, { params }),
                dropdownField: "building",
                paramFields: ["site_id", "client_id"],
                readOnly: true
            },
            description: {
                label: "Description",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (building_id, params) => fcaGateWay.post(`${serviceEndpoints.additionEndPoints.addAddition}/${building_id}/additions`, params),
        nameField: "name",
        permission: checkPermission("forms", "building_additions", "create")
    },
    "assets.building_id": {
        formHeading: "Building",
        fieldKeys: ["name", "main_building_type_id", "description", "client_id", "consultancy_id", "region_id", "site_id", "ownership_type"],
        fields: {
            name: {
                label: "Building Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            main_building_type_id: {
                label: "Building Type",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                dropdownFn: params =>
                    fcaGateWay.get(`${serviceEndpoints.buildingEndPoints.getBuildingTypesBasedOnClient}/building_types_dropdown`, { params }),
                dropdownField: "building_type",
                paramFields: ["client_id"],
                autoFieldKey: "main_building_type_id",
                readOnly: true
            },
            consultancy_id: {
                label: "Consultancy",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "consultancy_id",
                dropdownField: "consultancy"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            },
            region_id: {
                label: "Region",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "region_id",
                dropdownFn: params => fcaGateWay.get(`${serviceEndpoints.buildingTypeEndPoints.getRegionsBasedOnClient}`, { params }),
                dropdownField: "region",
                paramFields: ["client_id"],
                readOnly: true
            },
            site_id: {
                label: "Site",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "site_id",
                dropdownFn: params => fcaGateWay.get(`${serviceEndpoints.buildingEndPoints.getSitesBasedOnRegion}/${params?.region_id}/sites`),
                dropdownField: "site",
                paramFields: ["region_id"],
                readOnly: true
            },
            description: {
                label: "Description",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            ownership_type: {
                label: "Ownership Type",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                fieldOptions: [
                    { name: "Owned", id: "Owned" },
                    { name: "Leased", id: "Leased" }
                ],
                defaultValue: "Owned"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(serviceEndpoints.buildingEndPoints.addBuilding, params),
        nameField: "name",
        permission: checkPermission("forms", "buildings", "create")
    },
    "assets.region_id": {
        formHeading: "Region",
        fieldKeys: ["name", "consultancy_id", "client_id"],
        fields: {
            name: {
                label: "Region Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            consultancy_id: {
                label: "Consultancy",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "consultancy_id",
                dropdownField: "consultancy",
                readOnly: true
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                dropdownField: "client",
                autoFieldKey: "client_id"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(serviceEndpoints.regionEndPoints.addRegion, params),
        nameField: "name",
        permission: checkPermission("forms", "regions", "create")
    },
    "assets.site_id": {
        formHeading: "Site",
        fieldKeys: ["name", "consultancy_id", "client_id", "region_id"],
        fields: {
            name: {
                label: "Site Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            consultancy_id: {
                label: "Consultancy",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "consultancy_id",
                dropdownField: "consultancy"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                dropdownField: "client",
                autoFieldKey: "client_id"
            },
            region_id: {
                label: "Region",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "region_id",
                dropdownFn: params => fcaGateWay.get(`${serviceEndpoints.buildingTypeEndPoints.getRegionsBasedOnClient}`, { params }),
                dropdownField: "region",
                paramFields: ["client_id"],
                readOnly: true
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(serviceEndpoints.siteEndPoints.addSite, params),
        nameField: "name",
        permission: checkPermission("forms", "sites", "create")
    },
    "assets.floor_id": {
        formHeading: "Floor",
        fieldKeys: ["name", "consultancy_id", "client_id", "building_id", "description", "sort_order"],
        fields: {
            name: {
                label: "Floor Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            description: {
                label: "Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            },
            consultancy_id: {
                label: "Consultancy",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                dropdownField: "consultancy",
                autoFieldKey: "consultancy_id",
                readOnly: true
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                dropdownField: "client",
                autoFieldKey: "client_id"
            },
            building_id: {
                label: "Building",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "building_id",
                dropdownFn: params => fcaGateWay.get(`${serviceEndpoints.additionEndPoints.getAllBuildingsDropdown}/buildings_dropdown`, { params }),
                dropdownField: "building",
                paramFields: ["site_id", "project_id"],
                readOnly: true
            },
            sort_order: {
                label: "Sort Order",
                mandatory: false,
                showInForm: true,
                fieldType: "number",
                isZeroNotAllowed: true
            }
        },
        serviceFn: (building_id, params) => fcaGateWay.post(`${serviceEndpoints.floorEndPoints.addFloor}/${building_id}/floors`, params),
        nameField: "name",
        permission: checkPermission("forms", "floors", "create")
    },
    "assets.trade_id": {
        formHeading: "Trade",
        fieldKeys: ["name", "display_name", "table_header", "description", "color_code"],
        fields: {
            name: {
                label: "Trade Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            display_name: {
                label: "Display Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            table_header: {
                label: "BBI Heading",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            description: {
                label: "Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            },
            color_code: {
                label: "Building",
                mandatory: false,
                showInForm: true,
                fieldType: "color"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(`${serviceEndpoints.projectEndPoints.addTrade}/${id}/trades`, params),
        nameField: "name",
        permission: checkPermission("forms", "master_trades", "create")
    },
    "assets.system_id": {
        formHeading: "System",
        fieldKeys: ["name", "trade_id", "description", "color_code"],
        fields: {
            name: {
                label: "System Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            trade_id: {
                label: "Trade",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "trade_id",
                dropdownFn: params => fcaGateWay.get(serviceEndpoints.assetEndPoints.dropdown.trades, { params }),
                dropdownField: "trade",
                paramFields: ["client_id"],
                readOnly: true
            },
            description: {
                label: "Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            },
            color_code: {
                label: "Color",
                mandatory: false,
                showInForm: true,
                fieldType: "color"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(`${serviceEndpoints.projectEndPoints.addSystem}/${id}/systems`, params),
        nameField: "name",
        permission: checkPermission("forms", "master_systems", "create")
    },
    "assets.sub_system_id": {
        formHeading: "Subsystem",
        fieldKeys: ["name", "trade_id", "system_id", "description"],
        fields: {
            name: {
                label: "Subsystem Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            trade_id: {
                label: "Trade",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "trade_id",
                dropdownFn: params => fcaGateWay.get(serviceEndpoints.assetEndPoints.dropdown.trades, { params }),
                dropdownField: "trade",
                paramFields: ["client_id"],
                readOnly: true
            },
            system_id: {
                label: "System",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                autoFieldKey: "system_id",
                dropdownFn: params =>
                    fcaGateWay.get(serviceEndpoints.assetEndPoints.dropdown.systems, {
                        params
                    }),
                dropdownField: "systems",
                paramFields: ["trade_id", "client_id"],
                readOnly: true
            },
            description: {
                label: "Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(`${serviceEndpoints.projectEndPoints.addSubsystem}/${id}/sub_systems`, params),
        nameField: "name",
        permission: checkPermission("forms", "master_sub_systems", "create")
    },

    "buildings.main_building_type_id": {
        formHeading: "Building Type",
        fieldKeys: ["name", "client_id", "consultancy_id", "description"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            consultancy_id: {
                label: "Consultancy",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "consultancy_id",
                dropdownField: "consultancy"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            },
            description: {
                label: "Description",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (id, params) => fcaGateWay.post(serviceEndpoints.buildingTypeEndPoints.addBuildingType, params),
        nameField: "name",
        permission: checkPermission("forms", "main_building_types", "create")
    },
    "assets.asset_status_id": {
        formHeading: "Asset Status",
        fieldKeys: ["name", "client_id", "description"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            },
            description: {
                label: "Description",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (id, params) =>
            fcaGateWay.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/asset_statuses`, {
                asset_status: params
            }),
        nameField: "name",
        permission: checkPermission("forms", "asset_status", "create")
    },
    "assets.asset_type_id": {
        formHeading: "Asset Type",
        fieldKeys: ["name", "client_id", "description"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            },
            description: {
                label: "Description",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (id, params) =>
            fcaGateWay.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/asset_types`, {
                asset_type: params
            }),
        nameField: "name",
        permission: checkPermission("forms", "asset_types", "create")
    },
    "assets.client_asset_condition_id": {
        formHeading: "Asset Condition",
        fieldKeys: ["name", "client_id", "color_code", "description"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            },
            color_code: {
                label: "Color",
                mandatory: false,
                showInForm: true,
                fieldType: "color"
            },
            description: {
                label: "Description",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (id, params) =>
            fcaGateWay.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/client_asset_conditions`, {
                client_asset_condition: params
            }),
        nameField: "name",
        permission: checkPermission("forms", "asset_conditions", "create")
    },
    "assets.manufacturer": {
        formHeading: "Manufacturer",
        fieldKeys: ["name", "client_id", "description"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            },
            description: {
                label: "Asset Manufacturer Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (id, params) =>
            isEnabled("migrate_report_config")
                ? fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturerFastApi}`, params)
                : fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturers}`, params),
        nameField: "name",
        permission: checkPermission("forms", "manufacturers", "create")
    },
    "assets.main_category_id": {
        formHeading: "Main Category",
        fieldKeys: ["name", "client_id"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            }
        },
        serviceFn: (id, params) =>
            fcaGateWay.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettings}/main_categories`, {
                main_category: params
            }),
        nameField: "name",
        permission: checkPermission("forms", "main_categories", "create")
    },
    "assets.manufacturer_id": {
        formHeading: "Manufacturer",
        fieldKeys: ["name", "client_id", "description"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            },
            description: {
                label: "Asset Manufacturer Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (id, params) =>
            isEnabled("migrate_report_config")
                ? fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturerFastApi}`, params)
                : fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturers}`, params),
        nameField: "name",
        permission: checkPermission("forms", "manufacturers", "create")
    },
    manufacturer_id: {
        formHeading: "Manufacturer",
        fieldKeys: ["name", "client_id", "description"],
        fields: {
            name: {
                label: "Name",
                mandatory: true,
                showInForm: true,
                fieldType: "text"
            },
            client_id: {
                label: "Client",
                mandatory: true,
                showInForm: true,
                fieldType: "select",
                readOnly: true,
                autoFieldKey: "client_id",
                dropdownField: "client"
            },
            description: {
                label: "Asset Manufacturer Description",
                mandatory: false,
                showInForm: true,
                fieldType: "text"
            }
        },
        serviceFn: (id, params) =>
            isEnabled("migrate_report_config")
                ? fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturerFastApi}`, params)
                : fcaFastApi.post(`${serviceEndpoints.assetSettingsEndPoints.assetSettingsManufacturers}`, params),
        nameField: "name",
        permission: checkPermission("forms", "manufacturers", "create")
    }
};
